import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import ChartDonut from '../../../../components/charts/ChartDonut'
import ChartDonutSkeleton from '../../../../components/skeletons/ChartDonutSkeleton'
import { ChartColumnThemes } from '../../../../components/charts/types/ChartColumn'
import { GET_MULTIPLE_SHOPPING_CART_PAYMENT_METHODS } from '../../../../queries/multipleShoppingCarts'
import { DailyMonitoringDetailsFiltersContext } from '../../../../context/DailyMonitoringDetailsFiltersContext'
import { formatNumber } from '../../../../utils/Helpers'

const ShoppingCartsPaymentMethods = (): JSX.Element => {
  const { filters } = useContext(DailyMonitoringDetailsFiltersContext)

  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_MULTIPLE_SHOPPING_CART_PAYMENT_METHODS, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: {
        filters: {
          createdAt: {
            initialDate: `${filters.date.year}-${filters.date.month}||/M`,
            finalDate: `${filters.date.year}-${filters.date.month}||/M`,
            format: 'yyyy-M',
            time_zone: filters.date.time_zone
          }
        }
      }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartDonutSkeleton />
  if (loading || !data || error) return <ChartDonutSkeleton />
  if (!data.ordersAggs.aggregations) return <p>No data found</p>

  const labels: Array<string> = []
  const series: Array<number> = []

  labels.push('Cartão de crédito')
  labels.push('Cartão de débito')
  labels.push('Dinheiro')

  series.push(data.ordersAggs.aggregations.credit.gmv.value)
  series.push(data.ordersAggs.aggregations.debit.gmv.value)
  series.push(data.ordersAggs.aggregations.money.gmv.value)

  const options = {
    chart: {
      id: 'multiple-shopping-carts-payment-methods'
    },
    labels,
    yaxis: {
      show: false
    },
    fill: {
      opacity: 1
    },
    legend: {
      formatter: function (seriesName: string, opts: any) {
        return [seriesName, ' - R$ ', formatNumber(opts.w.globals.series[opts.seriesIndex], 2, true)]
      },
      width: 260,
      height: 400
    },
    dataLabels: {
      formatter: function (value: number) {
        return `${formatNumber(value, 2)}%`
      }
    },
    tooltip: {
      y: {
        formatter: (value: number) => {
          return formatNumber(value, 2, true)
        }
      }
    }
  }

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>Métodos de pagamento (na entrega)</Typography>
    <ChartDonut options={options} series={series} theme={ChartColumnThemes.green} type="donut" />
  </Paper>
}

export default ShoppingCartsPaymentMethods
